// imports
import { Address } from 'abitype';

// interfaces / types / consts
interface Pin {
  islandId: string;
  position: number[];
  type: 'campaign' | 'side';
}

// exports - heroes
export type HeroListFilter = 'all' | 'species_human' | 'species_elf' | 'species_emberling' | 'species_dragonkin';

// exports - generic
export type Status = 'idle' | 'loading' | 'error' | 'success';
export interface IWallet { address: Address; privateKey: Address }
export type TimeFormat = `${number}d ${number}h` | `${number}d` | `${number}h ${number}m` |
  `${number}h` | `${number}m ${number}s` | `${number}m` | `${number}s`;

export interface IModal { show(): void; hide(): void }
export interface ITraitMatching { id: string; icon: string; status: Status }
export interface IScrollableContainer { resetScroll(): void; scrollToId(id: string): void }
export interface INotification {
  body: string;
  title: string;
  newQuests: boolean;
  walletAddress: string;
}
export interface IActionItem {
  key: string;
  url?: string;
  icon?: string;
  display?: string;
  iconActive?: string;
  children?: IActionItem[];
  onClick?: () => void;
}

// exports - quests
export interface QuestCost { itemId: string; amount: number }
export enum QuestType { Side = 'side', Campaign = 'campaign' }
export enum QuestStatus { locked, available, inProgress, completed }
export interface QuestRewards extends QuestCost { minChance: number; maxChance: number; minThreshold: number; maxThreshold: number }
export interface Quest {
  id: string;
  name: string;
  pinId: string;
  crew: number[];
  type: QuestType;
  duration: number;
  cost: QuestCost[];
  traits: string[][];
  messageMid: string;
  status: QuestStatus;
  description: string;
  messageError: string;
  rewards: QuestRewards[];
  messageSuccess: string;
  points: { heroes: number[]; traits: number[][] };
  endTime?: number;
  startTime?: number;
  rewardChances?: number[];
  crewTraitMatching?: ITraitMatching[][];
}

// exports - meta
export interface Trait {
  id: string;
  value: string;
  type: string;
  description: string;
}
export interface Region {
  name: string;
  description: string;
}
export interface World {
  id: string;
  name: string;
  pins: { [key: string]: Pin };
  regions: { [key: string]: Region };
  islands: {
    [key: string]: Region & {
      regionId: string;
      cleansed: boolean;
    };
  };
}
export interface BackpackItem {
  id: string;
  name: string;
  type: string;
  info: string;
  visible: boolean;
  chainMetaId: string;
  description: string;
}

// exports - Map
export interface IMap {
  zoomOut(): void;
  centerView(): void;
  zoomToElement(regionId: string): void;
}
export type MapImageQuality = 'High' | 'Low';
export type MapViewState =
  | 'default'
  | 'zoomingIn'
  | 'zoomedIn'
  | 'zoomingOut';
export interface IMapState {
  visibility: boolean;
  viewState: MapViewState;
  imageQuality: MapImageQuality;
}
